<dx-text-box valueChangeEvent="keyup" (onValueChanged)="onValueChanged($event)" (onBlur)="onTouched()" [readOnly]="readonly()" [isValid]="isValid"
 [value]="value()" [disabled]="disabled()" [inputAttr]="inputAttr()"></dx-text-box>